import React, { useEffect, useState } from "react";
import { Dropdown, Card, Table, Badge, Col, Button, Form, InputGroup } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import Spinner from "../common/Spinner";
import Pagination from "../common/Pagination";
import { useDispatch } from "react-redux";
import profile from "../../images/blank-profile-picture.webp";
import { notifyError, notifyTopRight } from "../common/Toaster";
import axiosInstance from "../../services/AxiosInstance";
import { FaCrown, FaPlus, FaTrash } from "react-icons/fa";

export default function VipUsersManagement(props) {
  const [loader, setLoader] = useState(false);
  const [vipUsers, setVipUsers] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [listLength, setListLength] = useState(0);
  const [email, setEmail] = useState("");
  const [adding, setAdding] = useState(false);
  const [initialFetch, setInitialFetch] = useState(true);
  const limit = 10;

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  ///function to fetch all VIP users ///
  const getTableData = async () => {
    setLoader(true);
    try {
      const response = await axiosInstance.get('/admin/vip-users', {
        params: {
          page: currentPage + 1,
          limit: limit
        }
      });
      
      if (response?.status === 200 && response?.data?.data) {
        setVipUsers(response.data.data);
        setPageCount(response.data.pagination.totalPages);
        setListLength(response.data.pagination.totalCount);
        setInitialFetch(false);
      } else {
        notifyError("Failed to fetch VIP users");
      }
    } catch (error) {
      console.log(error, "error");
      notifyError("Failed to fetch VIP users");
    } finally {
      setLoader(false);
    }
  };

  const handleAddVipUser = async () => {
    if (!email.trim()) {
      notifyError("Please enter an email address");
      return;
    }
    
    setAdding(true);
    try {
      const response = await axiosInstance.post('/admin/vip-users', { email: email.trim() });
      
      if (response?.status === 200) {
        notifyTopRight("VIP user added successfully!");
        setEmail("");
        getTableData();
      }
    } catch (error) {
      notifyError(error.response?.data?.message || "Failed to add VIP user");
    } finally {
      setAdding(false);
    }
  };

  const handleRemoveVipUser = async (vipUserId) => {
    if (!window.confirm("Are you sure you want to remove this VIP user?")) {
      return;
    }
    
    setLoader(true);
    try {
      const response = await axiosInstance.delete(`/admin/vip-users/${vipUserId}`);
      
      if (response?.status === 200) {
        notifyTopRight("VIP user removed successfully!");
        getTableData();
      }
    } catch (error) {
      notifyError(error.response?.data?.message || "Failed to remove VIP user");
    } finally {
      setLoader(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAddVipUser();
    }
  };

  useEffect(() => {
    getTableData();
  }, [currentPage]);

  return (
    <div>
      <PageTitle activeMenu="VIP Users" motherMenu="Users" />
      <Col>
        <Card>
          <Card.Header className="d-block">
            <div className="d-flex justify-content-between align-items-center">
              <div className="col-8" style={{ flexGrow: 1 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "15px", maxWidth: "700px" }}>
                    <Form.Control
                      type="email"
                      placeholder="Enter email address..."
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      onKeyPress={handleKeyPress}
                      disabled={adding}
                      style={{ flex: 1, minWidth: "300px" }}
                    />
                    <button
                      onClick={handleAddVipUser}
                      disabled={adding || !email.trim()}
                      className='btn btn-primary'
                      style={{
                        backgroundColor: '#5A775C'
                      }}
                    >
                      {adding ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-1" />
                          Adding...
                        </>
                      ) : (
                        <>
                          <FaCrown className="mr-1" />
                          Add User
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Card.Header>
          <Card.Body>
            {loader ? (
              <Spinner />
            ) : (
              <Table responsive>
                <thead className="text-black">
                  <tr>
                    <th>
                      <strong>IMAGE</strong>
                    </th>
                    <th>
                      <strong>NAME</strong>
                    </th>
                    <th>
                      <strong>EMAIL</strong>
                    </th>
                    <th>
                      <strong>STATUS</strong>
                    </th>
                    <th>
                      <strong>ACTION</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {vipUsers?.map((item, i) => (
                    <tr key={i}>
                      <td>
                        <img
                          src={item.user?.profilePicture || profile}
                          width={70}
                          height={70}
                          alt="profile"
                          style={{ borderRadius: "50%" }}
                        />
                      </td>
                      <td>{item.user?.name || "N/A"}</td>
                      <td>{item.email}</td>
                                              <td>
                          <div
                            style={{
                              backgroundColor: item.status === 'Active' ? '#28a745' : '#ffc107',
                              color: item.status === 'Active' ? 'white' : 'black',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              fontSize: '12px',
                              fontWeight: '500',
                              display: 'inline-block',
                              minWidth: '60px',
                              textAlign: 'center'
                            }}
                          >
                            {item.status === 'Active' ? 'Active' : 'Pending'}
                          </div>
                        </td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle
                            variant=""
                            className="btn-link i-false"
                          >
                            {svg1}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item 
                              onClick={() => handleRemoveVipUser(item._id)}
                              className="text-danger"
                            >
                              <FaTrash className="mr-1" />
                              Remove
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
            <Pagination
              currentPage={currentPage}
              pageCount={pageCount}
              onPageChange={(selected) => setCurrentPage(selected)}
              listLength={listLength}
              limit={limit}
            />
          </Card.Body>
        </Card>
      </Col>
    </div>
  );
} 